var count = -1000000000; // eslint-disable-next-line no-plusplus

export var increment = function increment() {
  return count++;
}; // eslint-disable-next-line no-plusplus

export var decrement = function decrement() {
  return count--;
};